import MuiAccordion from '@mui/material/Accordion'
import { AccordionDetails, AccordionSummary } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  accordionDetailsStyles,
  accordionstyles
} from '../AccordionContent/AccordionContent.styles'
import {
  primaryColors,
  transparentColors
} from '@/assets/styles/helpers/colors.styles'
import styles from '../AccordionContent/AccordionContent.module.scss'
import DatePicker from '@/shared/components/DatePicker/DatePicker'
import Select from '@/shared/components/Select/Select'
import Button from '@/shared/components/Button/Button'
import { OptionType } from '@/shared/api/BaseAPI.model'
import DashboardExportModal from '@/shared/components/Modal/DashboardExportModal/DashboardExportModal'

interface ChartsSettingsAccordionProps {
  accordionIndex: number
  openAccordion: number
  handleAccordionClick: (index: number) => void
}

function ChartsSettingsAccordion(props: ChartsSettingsAccordionProps) {
  const { accordionIndex, openAccordion, handleAccordionClick } = props
  const { t } = useTranslation()
  const location = useLocation()

  const ingredientTypes = useMemo(
    () =>
      [
        { label: 'Weight (kg)', value: 'weight' },
        { label: 'Volume (L)', value: 'volume' },
        { label: 'Count', value: 'count' }
      ] as OptionType[],
    []
  )

  const [selectedIngredientType, setSelectedIngredientType] =
    useState<OptionType>(ingredientTypes[0])

  const [isExportModalOpen, setIsExportModalOpen] = useState(false)

  return (
    <MuiAccordion
      expanded={openAccordion === accordionIndex}
      onChange={() => handleAccordionClick(accordionIndex)}
      sx={{
        ...accordionstyles,
        background: transparentColors.whiteShade1
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: primaryColors.white }} />}
      >
        <p className={`${styles.accordionTitle} body-bold-medium`}>
          {t('SIDEBAR_ACCORDION.CHARTS_SETTINGS.TITLE')}
        </p>
      </AccordionSummary>
      <AccordionDetails sx={accordionDetailsStyles}>
        <div
          className={`${styles.accordionFormContainer} ${styles.justifyLeft}`}
        >
          <p className={`${styles.accordionDescription} body-medium`}>
            {t('SIDEBAR_ACCORDION.CHARTS_SETTINGS.DESCRIPTION')}
          </p>
          <DatePicker label={t('COMMON.DATE_RANGE')} />
          {location.pathname.includes('ingredients') && (
            <Select
              label={t('CHARTS_SETTINGS.INGREDIENT_TYPE')}
              options={ingredientTypes}
              value={selectedIngredientType}
              onChange={value => setSelectedIngredientType(value as OptionType)}
              hideClearIcon
            />
          )}
          <Button
            label={t('DASHBOARD.EXPORT_BUTTON')}
            variant="outlined"
            color="primary"
            maxWidth
            onClick={() => setIsExportModalOpen(!isExportModalOpen)}
          />
        </div>
      </AccordionDetails>
      <DashboardExportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
      />
    </MuiAccordion>
  )
}

export default ChartsSettingsAccordion
